const PADDING = '24px';
const PADDING_SMALL = '14px 24px 12px 24px';
const POPUP_HEIGHT = '80vh';
const POPUP_HEIGHT_SMALL = '83vh';
const PREVIEW_DIV_ID = 'metric-popup-preview';
const PRIMARY_ACTION_DIV_ID = 'metric-popup-action';
const CORE_TOGGLE_DIV_ID = 'metric-popup-core-toggle';

const MetricPopupConstants = {
  POPUP_HEIGHT_SMALL,
  PADDING,
  PADDING_SMALL,
  POPUP_HEIGHT,
  PREVIEW_DIV_ID,
  PRIMARY_ACTION_DIV_ID,
  CORE_TOGGLE_DIV_ID,
};

export default MetricPopupConstants;
